import styled from 'styled-components';

import { HOME, SPACE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

/** The sign-ups block under the traffic figures, on the same overview card. */
export const Block = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

/** The divider between the traffic half and this one, with room on both sides of it. */
export const Gap = styled.div`
  padding: ${SPACE[16]} ${SPACE[0]} ${SPACE[8]};
`;

/** The section's mark (a bill) before its heading. */
export const HeadMark = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACE[12]};
  min-width: 0;
`;

export const Head = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${SPACE[8]} ${SPACE[16]};
  padding: ${SPACE[4]} ${SPACE[4]} ${SPACE[0]};
`;

export const HeadText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
  min-width: 0;
`;

export const Title = styled(Text)`
  margin: ${SPACE[0]};
  font-size: 18px;
  font-weight: 700;
  color: ${HOME.t300};
`;

export const Sub = styled(Text)`
  font-size: 14px;
  font-weight: 300;
  color: ${HOME.t300};
`;

export const PlayersLink = styled.a`
  font-size: 14px;
  font-weight: 600;
  color: ${HOME.t50};
  text-decoration: underline;
  text-underline-offset: 3px;
  white-space: nowrap;
`;
